import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { ReactNode, useRef, useEffect, useState } from 'react';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = ({
  children,
  open,
  ...props
}: {
  children: ReactNode;
  open: boolean;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(open ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [open]);

  return (
    <div
      style={{ height }}
      className="transition-height duration-300 ease-in-out overflow-hidden"
    >
      <CollapsiblePrimitive.CollapsibleContent ref={contentRef} {...props}>
        {children}
      </CollapsiblePrimitive.CollapsibleContent>
    </div>
  );
};

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
